module.exports = __webpack_public_path__ + "img/no-feed.bf1a2910.svg";